import { gsap } from 'gsap';

const animateFrom = (elem, direction, index) => {
    console.log(index);

    direction = direction || 1;
    let x = 0,
        y = direction * 100;
    if (elem.classList.contains('gs_reveal_fromLeft')) {
        x = -100;
        y = 0;
    } else if (elem.classList.contains('gs_reveal_fromRight')) {
        x = 100;
        y = 0;
    }
    elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    elem.style.opacity = '0';
    gsap.fromTo(
        elem,
        { x: x, y: y, autoAlpha: 0 },
        {
            duration: 1.25,
            x: 0,
            y: 0,
            autoAlpha: 1,
            ease: 'expo',
            overwrite: 'auto',
            delay: index * 0.1,
        }
    );
};

const delay = n => {
    n = n || 2000;
    return new Promise(done => {
        setTimeout(() => {
            done();
        }, n);
    });
};

const hide = elem => {
    gsap.set(elem, { autoAlpha: 0 });
};

const getCookie = key => {
    if (!key) return null;

    return (
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    '(?:(?:^|.*;)\\s*' +
                        encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
                        '\\s*\\=\\s*([^;]*).*$)|^.*$'
                ),
                '$1'
            )
        ) || null
    );
};

export { animateFrom, delay, hide, getCookie };
